export const brandPrimary = 'rgb(46, 91, 134)';
export const brandLightGrey = 'rgb(201, 201, 201)';
export const brandMediumGrey = 'rgb(117, 117, 117)';
export const brandDarkGrey = 'rgb(66, 66, 66)';
export const brandPurple = 'rgb(76, 42, 72)';
export const brandNavy = 'rgb(12, 35, 64)';
export const brandBundleGreen = 'rgba(190, 255, 0, 1)';

// Primary and Secondary color
export const brandWhite = 'rgb(255, 255, 255)';
export const brandBlack = 'rgb(0, 0, 0)';
export const brandDarkBlack = 'rgb(39, 39, 39)';

// Secondary Layer colors
export const brandSelectedGrey = 'rgb(241, 241, 241)';
export const brandBackgroundGrey = 'rgb(231, 231, 231)';
export const brandActiveGrey = 'rgb(219, 219, 219)';
export const brandPlaceholderGrey = 'rgb(153, 153, 153)';

// Product State Text Color
export const brandBlue = 'rgb(0, 0, 255)'; // new product
export const brandRed = 'rgb(255, 0, 0)'; // sold out
